import { APP_VERSION } from '../version';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="text-center text-xs text-slate-400 py-4 px-4">
      © {year} LS Desenvolvimento de Software LTDA — Todos os direitos reservados.
      <span className="mx-1">·</span>v{APP_VERSION}
    </footer>
  );
}
